import type {TokenClaimsSerializer} from "@/generated/DjangoTypes";
import {selectedCompanyIdAtom} from "@/store/jotaiAtoms";
import useTokenStore from "@/store/token";
import {fetchCompany} from "@/utils/loaderUtils";
import {createFileRoute, redirect} from "@tanstack/react-router";
import {zodValidator} from "@tanstack/zod-adapter";
import {getDefaultStore} from "jotai";
import {jwtDecode} from "jwt-decode";
import {z} from "zod";

const searchSchema = z.object({
  addCountry: z.boolean().optional(),
  tab: z.enum(["competitors", "keywords", "opportunities", "overview"]).catch("overview"),
});

export const Route = createFileRoute("/_authenticated/search-visibility")({
  validateSearch: zodValidator(searchSchema),
  loaderDeps: ({search}) => ({addCountry: search.addCountry, tab: search.tab}),
  loader: async ({deps}) => {
    const token = useTokenStore.getState().access;
    if (!token) {
      throw redirect({to: "/login", replace: true});
    }

    const claims = jwtDecode<TokenClaimsSerializer>(token);
    const selectedCompanyId = getDefaultStore().get(selectedCompanyIdAtom);
    const companyId = selectedCompanyId ?? claims.sub_brand_ids?.[0];

    if (!companyId) {
      throw redirect({to: "/", replace: true});
    }

    try {
      const company = await fetchCompany(companyId);

      if (company.agency?.multiple_brands) {
        throw redirect({
          to: "/agency/$agencyId/subbrand/$companyId/search-visibility",
          params: {agencyId: company.agency.id, companyId: company.id},
          search: {addCountry: deps.addCountry, tab: deps.tab},
          replace: true,
        });
      }

      throw redirect({
        to: "/company/$companyId/search-visibility",
        params: {companyId: company.id},
        search: {addCountry: deps.addCountry, tab: deps.tab},
        replace: true,
      });
    } catch (error) {
      if (error && typeof error === "object" && "isRedirect" in error) {
        throw error;
      }
      throw redirect({
        to: "/company/$companyId/search-visibility",
        params: {companyId},
        search: {addCountry: deps.addCountry, tab: deps.tab},
        replace: true,
      });
    }
  },
});
